export enum PageCode {
	Classic = 'classic',
	Anime = 'anime',
	Hero = 'hero',
	Toei = 'toei',
	Other = 'other',
	All = 'all'
}
export const Classic = {
	code: PageCode.Classic,
	label: '昭和の名作ライブラリー',
	genre: '昭和名作'
};
export const Anime = {
	code: PageCode.Anime,
	label: '想い出のアニメライブラリー',
	genre: 'アニメ'
};
export const Hero = {
	code: PageCode.Hero,
	label: '甦るヒーローライブラリー',
	genre: 'ヒーロー'
};
export const Toei = {
	code: PageCode.Toei,
	label: '東映作品',
	genre: '東映作品'
};
export const Other = { code: PageCode.Other, label: 'その他', genre: 'その他' };
export const API_BASE = 'https://bestfield.microcms.io/api/v1/';
export const API_KEY = '5edc7239-5507-4838-82f7-2df26fd0eb08';
